import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import TabHeader from './TabHeader';
import {
  ACCOUNT_TYPE,
  SAMPLE_INSIGHT_BOARDS_COLUMNS,
  GENERAL_INSIGHT_BOARDS_COLUMNS,
  INSIGHT_TYPE,
} from 'constants/constants';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import { Tooltip } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import { searchData } from 'utils/utils';
import ContextPopover from 'components/shared/context-menu/ContextPopover';
import LinkButton from 'components/shared/button/LinkButton';
import classes from './View.module.scss';
import {
  updateInsightBoardTitle,
  deleteInsightBoard,
  shareInsightBoard,
  notifyRecipientByMail,
} from 'store/customer/customer-view-actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAppUsers,
  setInsightBoards,
  setNotificationEmailStatus,
  setSelectedCustomer,
} from 'store/customer/customerViewSlice';
import { getTeamMembers } from 'services/configure-priority.service';
import ShareInsightBoard from '../insights/share-insight/ShareInsightBoard';
import { toast } from 'react-toastify';
import CopyInsightBoard from '../insights/copy-insight/CopyInsightBoard';
import EditInsightBoardTitle from '../insights/edit-insight/EditInsightBoardTitle';
import Confirmation from 'components/shared/confirmation/Confirmation';
import { areas } from 'constants/constants';
import { Spinner } from 'components/shared/loader/Spinner';
import { usePromiseTracker } from 'react-promise-tracker';
import './InsightBoardsList.scss';

const InsightBoardsList = ({ page, insightBoards, onItemClickHandler }) => {
  const dispatch = useDispatch();
  const { unixId } = useSelector((state) => state.Auth.userClaimObject);
  const [filteredBoards, setFilteredBoards] = useState();
  const appActiveUsers = useSelector((state) => state?.CustomerView?.appUsers);
  const tabHeaderRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [currentInsight, setCurrentInsight] = useState(null);
  const [shareModalShow, setShareModalShow] = useState(false);
  const [copyModalShow, setCopyModalShow] = useState(false);
  const [modalConfirmShow, setConfirmModalShow] = useState(false);
  const notifyUsersByEmailList = useSelector(
    (state) => state?.CustomerView?.notifyUsersByEmailList
  );
  const getEmailNotificationStatus = useSelector(
    (state) => state?.CustomerView?.notificationEmailStatus
  );
  const [selectedUsersToNotify, setselectedUsersToNotify] = useState([]);
  const filterOptions = [
    { value: 'All Insight Boards', label: 'All Insight Boards' },
    { value: 'Created By Me', label: 'Created By Me' },
    { value: 'Shared With Me', label: 'Shared With Me' },
  ];
  const { promiseInProgress: loadingViews } = usePromiseTracker({
    area: areas.customerViewList,
  });

  useEffect(() => {
    setFilteredBoards(insightBoards.filter((ib) => page === ib.insightType));
    handleSearchOrFilter('', filterOptions[0]);
  }, [insightBoards]);

  const getOptionsTosharewith = async () => {
    if (appActiveUsers?.length === 0) {
      dispatch(
        setAppUsers(
          await getTeamMembers(currentInsight.accountId, ACCOUNT_TYPE.shared)
        )
      );
    }
  };

  const shareInsightHandler = () => {
    setAnchorEl(null);
    getOptionsTosharewith();
    setShareModalShow(true);
  };

  const copyInsightHandler = () => {
    setAnchorEl(null);
    setCopyModalShow(true);
    dispatch(setSelectedCustomer([]));
  };

  const editInsightHandler = () => {
    setAnchorEl(null);
    setModalShow(true);
  };

  const deleteInsightHandler = () => {
    //call delete api
    setAnchorEl(null);
    setConfirmModalShow(true);
  };

  const handleSave = async (title) => {
    const insightId = currentInsight?.Id;
    try {
      await updateInsightBoardTitle(title, insightId);
      const insightData = insightBoards?.map((item) => {
        let updatedTitle = item.name;
        if (item.Id === currentInsight.Id) {
          updatedTitle = title;
        }
        return { ...item, name: updatedTitle };
      });

      dispatch(setInsightBoards(insightData));
    } catch (err) {
      console.log(err.message);
    }
    setModalShow(false);
  };

  const getColumns = () => {
    const columns =
      page === INSIGHT_TYPE.GENERAL
        ? GENERAL_INSIGHT_BOARDS_COLUMNS
        : SAMPLE_INSIGHT_BOARDS_COLUMNS;

    return columns.map((col) => {
      if (col.dataIndex === 'name') {
        return {
          ...col,
          render: (_, record) => (
            <span className='span-link text text__normal text__bold'>
              <Link
                to={record.name}
                onClick={onItemClickHandler.bind(this, record)}>
                {record.name}{' '}
              </Link>
              {record.sharedBy ? (
                <span className='ms-2'>
                  <OverlayTrigger overlay={tooltip(record.sharedBy)}>
                    <i className='icon icon__sharedby'></i>
                  </OverlayTrigger>
                </span>
              ) : (
                ''
              )}
            </span>
          ),
        };
      }
      return col;
    });
  };

  const tooltip = (sharedBy) => {
    return (
      <Tooltip
        className='gne-tooltip'
        bsclass='gne-tooltip tooltip__white'>
        <p className='text text__x-small mb-1'>
          <b>Shared by: </b>
          {sharedBy}
        </p>
      </Tooltip>
    );
  };

  const handleSearchOrFilter = (searchedText, selectedFilter) => {
    let filterPool = insightBoards.filter((ib) => page === ib.insightType);

    switch (selectedFilter) {
      case filterOptions[1].value:
        filterPool = filterPool.filter((ib) => ib.sharedBy === null);
        break;
      case filterOptions[2].value:
        filterPool = filterPool.filter((ib) => ib.sharedBy);
        break;
      default:
        break;
    }

    if (searchedText !== '') {
      filterPool = searchData(filterPool, searchedText);
    }

    setFilteredBoards(filterPool);
  };

  const contextContent = (
    <>
      <div
        className='menu-item'
        onClick={shareInsightHandler}>
        <i className={`icon icon__share me-1 ${classes['edit-icon']}`}></i>
        <LinkButton className={classes['context-menu-button']}>
          Share
        </LinkButton>
      </div>
      <div
        className='menu-item'
        onClick={copyInsightHandler}>
        <i className='icon icon__copy-insight me-2'></i>
        <LinkButton className={classes['context-menu-button']}>
          Copy To
        </LinkButton>
      </div>
      <div
        className='menu-item'
        onClick={editInsightHandler}>
        <i
          className={`icon icon__configureEditInsightTile ${classes['edit-icon']}`}></i>
        <LinkButton className={classes['context-menu-button']}>
          Rename Title
        </LinkButton>
      </div>
      <div
        className='menu-item'
        onClick={deleteInsightHandler}>
        <i className='icon icon__delete-insight me-2'></i>
        <LinkButton className={classes['context-menu-button']}>
          Delete
        </LinkButton>
      </div>
    </>
  );
  const onHide = () => {
    setModalShow(false);
    setConfirmModalShow(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const saveShareInsightHandler = async (shareWith) => {
    const sharedByName = appActiveUsers?.filter(
      (uid) => uid?.unixId.toLowerCase() === unixId.toLowerCase()
    );
    let insightsBoard = {
      insightBorardIdToShare: currentInsight.Id,
      accountId: currentInsight.accountId,
      insightsBoardName: currentInsight.name || currentInsight.accountName,
      isPriorityAccount: currentInsight.isPriorityAccount
        ? currentInsight.isPriorityAccount
        : 'N',
      boardType: currentInsight.boardType,
      sharedBy: sharedByName?.[0]?.label,
    };
    const response = await shareInsightBoard(insightsBoard, shareWith);
    let successMsg = currentInsight.accountName + ' Shared with : ';
    if (!response?.some((item) => item.message !== 'success')) {
      response.map((rs, index) => {
        successMsg += (index ? ', ' : '') + rs.sharedWith;
        return 'success';
      });
      toast.success(successMsg);
      if (getEmailNotificationStatus) {
        saveNotifyInsightHandler(selectedUsersToNotify);
        dispatch(setNotificationEmailStatus(false));
      }
    } else {
      toast.error('Operation Failed');
      return 'success';
    }
  };

  const onDelete = async (id) => {
    //API integration
    try {
      const response = await deleteInsightBoard(id);
      if (response) {
        const insightDataExceptDeleted = insightBoards.filter(
          (item) => item.Id !== id
        );
        dispatch(setInsightBoards(insightDataExceptDeleted));
        if (tabHeaderRef.current) {
          tabHeaderRef.current.clearSearch();
        }
      }
    } catch (err) {
      console.log(err.message);
    }
    setConfirmModalShow(false);
  };

  const saveNotifyInsightHandler = async (notifyEmailWith) => {
    const sharedByName = appActiveUsers?.filter(
      (uid) => uid?.unixId.toLowerCase() === unixId.toLowerCase()
    );
    let insightsBoard = {
      insightBorardIdToShare: currentInsight.Id,
      accountId: currentInsight.accountId,
      insightsBoardName: currentInsight.name || currentInsight.accountName,
      isPriorityAccount: currentInsight.isPriorityAccount,
      boardType: currentInsight.boardType,
      sharedBy: sharedByName?.[0]?.label,
    };

    await notifyRecipientByMail(insightsBoard, notifyUsersByEmailList);
  };

  const viewActionHandler = (record, e) => {
    setCurrentInsight(record);
    if (page === INSIGHT_TYPE.SAMPLE) {
      setCopyModalShow(true);
    } else {
      setAnchorEl(e.currentTarget);
    }
  };
  const sortData = () => {};

  return (
    <>
      <TabHeader
        ref={tabHeaderRef}
        page={page}
        handleSearch={handleSearchOrFilter}
        filterViewOptions={filterOptions}
      />
      {loadingViews ? (
        <Spinner />
      ) : (
        <div className='mt-3'>
          <ConfigurableTable
            tableName={'myViews'}
            rows={filteredBoards}
            pagination={false}
            columns={getColumns()}
            onSort={sortData}
            showActionIcon={true}
            actionColumnTitle='Actions'
            actionColumnWidth={110}
            onActionClickHandler={viewActionHandler}
            customCss='insights-board'
            dimentions={{ x: 800 }}
            iconProps={{
              iconCss:
                page === INSIGHT_TYPE.GENERAL ? 'card-toggle' : 'copy-insight',
            }}
          />
        </div>
      )}
      <ContextPopover
        anchor={anchorEl}
        onHandleClose={handleClose}
        content={contextContent}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      />
      <ShareInsightBoard
        showModal={shareModalShow}
        setShowModal={setShareModalShow}
        currentInsight={currentInsight}
        dropdownShareOptions={appActiveUsers}
        saveShareInsightHandler={(shareWith) => {
          saveShareInsightHandler(shareWith);
        }}
        saveNotifyInsightHandler={(notifyWithshare) => {
          if (notifyWithshare?.length) {
            setselectedUsersToNotify(notifyWithshare);
          }
        }}
      />
      <CopyInsightBoard
        showModal={copyModalShow}
        setShowModal={setCopyModalShow}
        currentInsight={currentInsight}
      />
      <EditInsightBoardTitle
        show={modalShow}
        handleSave={handleSave}
        onHide={onHide}
        title={currentInsight?.name}
        insightAccountId={currentInsight?.Id}
      />
      <Confirmation
        show={modalConfirmShow}
        onOK={onDelete}
        onHide={onHide}
        id={currentInsight?.Id}
      />
    </>
  );
};

export default InsightBoardsList;
